import { useContext, useMemo } from 'react';
import { Checkbox, CheckboxProps } from '@givebutter/primitives/checkbox';
import { TableContext } from 'components/table/TableContext';
import { twMerge } from 'tailwind-merge';

interface TableHeaderCheckboxProps<T> extends Omit<CheckboxProps, 'checked' | 'onCheckedChange'> {}

const TableHeaderCheckbox = <T,>(props: TableHeaderCheckboxProps<T>) => {
    const { className = '', ...rest } = props;
    const { table } = useContext(TableContext);
    const isChecked = table.getIsSomePageRowsSelected()
        ? 'indeterminate'
        : table.getIsAllPageRowsSelected();

    const checkboxLabel = useMemo(() => {
        return `${isChecked ? 'Uncheck' : 'Check'} all rows`;
    }, [isChecked]);

    return (
        <Checkbox
            className={twMerge('flex items-center justify-center', className)}
            checked={isChecked}
            onCheckedChange={checked => {
                table.toggleAllPageRowsSelected(checked === true);
            }}
            aria-label={checkboxLabel}
            {...rest}
        />
    );
};

export { TableHeaderCheckbox };
export type { TableHeaderCheckboxProps };
